import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  CustodianDto,
  ManifestAndPassKey,
} from '../../types/upload-new-eviidence/evidenceSourceTypes';

export interface INewUploadEvidence {
  evidenceName: string;
  clientReference: string;
  intakeCompletion: any;
  password?: string[];
  custodianType?: string;
  singleCustodian?: CustodianDto;
  uploadedManifest?: ManifestAndPassKey;
  uploadedPasskey?: ManifestAndPassKey[];
  handlingInstructions?: string;
  isAdditionalInstructions: boolean;
  defaultProcessingSettings?: any;
  acknowledgementDateTime?: string;
}

interface SelectedProject {
  projectId: string;
  projectName: string;
  projectAlphaCode?: string;
  isNonConsilioWorkflow?: boolean;
}

interface IUploadEvidenceSourceState {
  selectedProject?: SelectedProject;
  sourceDetails?: INewUploadEvidence;
  evidenceSourceSessionId?: string;
}

const initialState: IUploadEvidenceSourceState = {
  selectedProject: undefined,
  sourceDetails: undefined,
  evidenceSourceSessionId: undefined,
};

const uploadEvidenceSourceSlice = createSlice({
  name: 'uploadEvidenceSource',
  initialState,
  reducers: {
    setSelectedProjectForEvidenceSource: (
      state,
      action: PayloadAction<SelectedProject | undefined>
    ) => {
      state.selectedProject = action.payload;
    },
    setEvidenceSourceDetails(
      state,
      action: PayloadAction<INewUploadEvidence | undefined>
    ) {
      state.sourceDetails = action.payload;
    },
    setEvidenceSourceSessionId(
      state,
      action: PayloadAction<string | undefined>
    ) {
      state.evidenceSourceSessionId = action.payload;
    },
    clearUploadEvidenceSource: () => initialState,
  },
});

export const {
  setSelectedProjectForEvidenceSource,
  setEvidenceSourceDetails,
  setEvidenceSourceSessionId,
  clearUploadEvidenceSource,
} = uploadEvidenceSourceSlice.actions;

export default uploadEvidenceSourceSlice.reducer;
